import React, { useContext, useRef } from "react";
import OnColorContext from "../../../contexts/OnColorContext";
import isNotEmpty from "../../../utils/isNotEmpty";
import ButtonAtm from "../../atoms/ButtonAtm";
import TextAtm from "../../atoms/TextAtm";
import FlexContainerOrg from "../../organisms/FlexContainerOrg";
import PushOrg from "../../organisms/PushOrg";
import ErrorMessage from "../InputMol/Components/ErrorMessage";
import { FileNameWithButton, StyledFileIcon, StyledFileTrashIcon, StyledUploadIcon, TextWithLines, UploadElement, Wrapper } from "./UploadMol.styled";
var UploadMol = function UploadMol(_ref) {
  var uploadedFiles = _ref.uploadedFiles,
    buttonText = _ref.buttonText,
    separatorText = _ref.separatorText,
    draggerText = _ref.draggerText,
    onDrop = _ref.onDrop,
    onChange = _ref.onChange,
    handleRemoveFile = _ref.handleRemoveFile,
    hasError = _ref.hasError,
    errorMessage = _ref.errorMessage,
    acceptExtensions = _ref.acceptExtensions;
  var onColor = useContext(OnColorContext);
  var fileInputRef = useRef(null);
  var handleButtonClick = function handleButtonClick() {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  var filesElements = uploadedFiles.map(function (file, index) {
    return /*#__PURE__*/React.createElement(PushOrg, {
      bottomSpace: 2,
      key: file.name
    }, /*#__PURE__*/React.createElement(FlexContainerOrg, {
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(PushOrg, {
      rightSpace: 1
    }, /*#__PURE__*/React.createElement(StyledFileIcon, {
      $onColor: onColor
    })), /*#__PURE__*/React.createElement(FileNameWithButton, {
      justifyContent: "space-between",
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(TextAtm, {
      typography: "small2",
      emphasis: "high"
    }, file.name), /*#__PURE__*/React.createElement(StyledFileTrashIcon, {
      $onColor: onColor,
      onClick: function onClick() {
        return handleRemoveFile(index);
      }
    }))));
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Wrapper, {
    $onColor: onColor,
    $hasError: !!hasError
  }, isNotEmpty(filesElements) && filesElements.length > 0 ? /*#__PURE__*/React.createElement(PushOrg, {
    bottomSpace: 4
  }, filesElements) : null, /*#__PURE__*/React.createElement(UploadElement, {
    onDrop: onDrop,
    onDragOver: function onDragOver(event) {
      return event.preventDefault();
    }
  }, /*#__PURE__*/React.createElement(PushOrg, {
    bottomSpace: 2
  }, /*#__PURE__*/React.createElement(StyledUploadIcon, null)), /*#__PURE__*/React.createElement(TextAtm, {
    typography: "medium2_s",
    pushSpace: 2
  }, draggerText), /*#__PURE__*/React.createElement(TextWithLines, {
    typography: "nano2_u",
    pushSpace: 2,
    $onColor: onColor
  }, separatorText), /*#__PURE__*/React.createElement(ButtonAtm, {
    size: "small",
    color: "dark",
    variant: "outlined",
    title: buttonText,
    onClick: handleButtonClick
  }, buttonText), /*#__PURE__*/React.createElement("input", {
    type: "file",
    hidden: true,
    id: "file-input",
    ref: fileInputRef,
    onChange: onChange,
    accept: acceptExtensions,
    multiple: true
  }))), hasError ? /*#__PURE__*/React.createElement(ErrorMessage, {
    message: errorMessage
  }) : null);
};
export default UploadMol;